import { Button, Stack } from "@mui/material";
import { MouseEvent } from "react";
import { Controller, FieldValues, Path, useFormContext } from "react-hook-form";

import { useGetAttachmentSignedUrl } from "./useGetAttachmentSignedUrl";

import { FileBlock } from "@/components/elements/attachment/file";
import { FileIcon } from "@/components/elements/attachment/file-icon";

export type AttachmentViewProps<TFormValues extends FieldValues> = {
  name: Path<TFormValues>;
  label: string;
};

export function AttachmentView<TFormValues extends FieldValues>({ name }: AttachmentViewProps<TFormValues>) {
  const { control } = useFormContext<TFormValues>();

  const { downloadAttachmentWithSignedUrl } = useGetAttachmentSignedUrl();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => {
        const value = field.value;
        return (
          <Stack key={name} spacing={1}>
            {value.map((urlAndName: string) => {
              const { url, name } = JSON.parse(urlAndName);
              return (
                <Button
                  size="small"
                  variant="outlined"
                  sx={{ justifyContent: "flex-start" }}
                  key={name}
                  onClick={(event: MouseEvent) => {
                    event.preventDefault();
                    downloadAttachmentWithSignedUrl({ payload: { url } });
                  }}
                  startIcon={<FileIcon name={name} fontSize={22} />}
                >
                  <FileBlock name={name} />
                </Button>
              );
            })}
          </Stack>
        );
      }}
    />
  );
}
